var map = {
	"./aparthotelclub/ic_location_pin.png": 20213,
	"./beachful/ic_location_pin.png": 76485,
	"./castlepedia/ic_location_pin.png": 26059,
	"./cocktayl/ic_location_pin.png": 33419,
	"./ic_location_pin.png": 69692,
	"./luxresortclub/ic_location_pin.png": 7280,
	"./parkful/ic_location_pin.png": 30694,
	"./prefabworld/ic_location_pin.png": 51527,
	"./rooftopclub/ic_location_pin.png": 7357,
	"./spaclub/ic_location_pin.png": 37509,
	"./worldcasino/ic_location_pin.png": 93062,
	"./zoopedia/ic_location_pin.png": 63354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91016;